export default "__VITE_ASSET__968e0826__"